function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import { useGridApiMethod } from "../../utils/useGridApiMethod.js";
import { useGridLogger } from "../../utils/useGridLogger.js";
import { exportAs } from "../../../utils/exportAs.js";
import { buildCSV } from "./serializers/csvSerializer.js";
import { getColumnsToExport, defaultGetRowsToExport } from "./utils.js";
import { useGridRegisterPipeProcessor } from "../../core/pipeProcessing/index.js";
import { GridCsvExportMenuItem } from "../../../components/toolbar/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @requires useGridColumns (state)
 * @requires useGridFilter (state)
 * @requires useGridSorting (state)
 * @requires useGridSelection (state)
 * @requires useGridParamsApi (method)
 */ export var useGridCsvExport = function(apiRef, props) {
    var logger = useGridLogger(apiRef, 'useGridCsvExport');
    var ignoreValueFormatterProp = props.ignoreValueFormatterDuringExport;
    var ignoreValueFormatter = ((typeof ignoreValueFormatterProp === "undefined" ? "undefined" : _type_of(ignoreValueFormatterProp)) === 'object' ? ignoreValueFormatterProp === null || ignoreValueFormatterProp === void 0 ? void 0 : ignoreValueFormatterProp.csvExport : ignoreValueFormatterProp) || false;
    var getDataAsCsv = React.useCallback(function() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        logger.debug("Get data as CSV");
        var exportedColumns = getColumnsToExport({
            apiRef: apiRef,
            options: options
        });
        var _options_getRowsToExport;
        var getRowsToExport = (_options_getRowsToExport = options.getRowsToExport) !== null && _options_getRowsToExport !== void 0 ? _options_getRowsToExport : defaultGetRowsToExport;
        var exportedRowIds = getRowsToExport({
            apiRef: apiRef
        });
        var _options_shouldAppendQuotes, _options_includeHeaders, _options_includeColumnGroupsHeaders, _options_escapeFormulas;
        return buildCSV({
            columns: exportedColumns,
            rowIds: exportedRowIds,
            csvOptions: {
                delimiter: options.delimiter || ',',
                shouldAppendQuotes: (_options_shouldAppendQuotes = options.shouldAppendQuotes) !== null && _options_shouldAppendQuotes !== void 0 ? _options_shouldAppendQuotes : true,
                includeHeaders: (_options_includeHeaders = options.includeHeaders) !== null && _options_includeHeaders !== void 0 ? _options_includeHeaders : true,
                includeColumnGroupsHeaders: (_options_includeColumnGroupsHeaders = options.includeColumnGroupsHeaders) !== null && _options_includeColumnGroupsHeaders !== void 0 ? _options_includeColumnGroupsHeaders : true,
                escapeFormulas: (_options_escapeFormulas = options.escapeFormulas) !== null && _options_escapeFormulas !== void 0 ? _options_escapeFormulas : true
            },
            ignoreValueFormatter: ignoreValueFormatter,
            apiRef: apiRef
        });
    }, [
        logger,
        apiRef,
        ignoreValueFormatter
    ]);
    var exportDataAsCsv = React.useCallback(function(options) {
        logger.debug("Export data as CSV");
        var csv = getDataAsCsv(options);
        var blob = new Blob([
            (options === null || options === void 0 ? void 0 : options.utf8WithBom) ? new Uint8Array([
                0xef,
                0xbb,
                0xbf
            ]) : '',
            csv
        ], {
            type: 'text/csv'
        });
        exportAs(blob, 'csv', options === null || options === void 0 ? void 0 : options.fileName);
    }, [
        logger,
        getDataAsCsv
    ]);
    var csvExportApi = {
        getDataAsCsv: getDataAsCsv,
        exportDataAsCsv: exportDataAsCsv
    };
    useGridApiMethod(apiRef, csvExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ var addExportMenuButtons = React.useCallback(function(initialValue, options) {
        var _options_csvOptions;
        if ((_options_csvOptions = options.csvOptions) === null || _options_csvOptions === void 0 ? void 0 : _options_csvOptions.disableToolbarButton) {
            return initialValue;
        }
        return _to_consumable_array(initialValue).concat([
            {
                component: /*#__PURE__*/ _jsx(GridCsvExportMenuItem, {
                    options: options.csvOptions
                }),
                componentName: 'csvExport'
            }
        ]);
    }, []);
    useGridRegisterPipeProcessor(apiRef, 'exportMenu', addExportMenuButtons);
};
